import { Vector2 } from '@babylonjs/core/Maths/math';
import { EasingFunction, CubicEase } from '@babylonjs/core/Animations/easing';

import { SatelliteEntity } from './satelliteEntity';

export let gravityRatio = 10;
let grabCurve = new CubicEase();
grabCurve.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);

export const Lerp = (a: number, b: number, alpha: number): number => {
    return a + alpha * (b - a);
}

export class GravityEntity extends SatelliteEntity {
    
    public gravity = 1;

    public gravityField = 1;

    protected cycleAbsorb = 1;
    
    public satellites: SatelliteEntity[] = [];

    public cycleSize = 1;

    public setGravity(gravity: number) {
        this.gravity = gravity;
        this.updateGravityField();
    }

    protected _setSize(size: number) {
        this.size = size;
        this.updateGravityField();
    }

    private updateGravityField() {
        this.gravityField = Math.sqrt(this.size * this.gravity) * gravityRatio;
    }

    public getSatelliteRadius(num: number): number {
        return (2 + num) * this.size;
    }

    public satelliteCycle() {
        for (let i = 0; i < this.satellites.length; i++) {
            const satellite = this.satellites[i];
            const { stationaryVelocity, stationaryRadius, cycle, offset} = satellite;
            satellite.stationaryRadius = Lerp(stationaryRadius, this.getSatelliteRadius(i), 0.1);
            const x = ((this.size * 1.5) + stationaryRadius) * Math.cos((stationaryVelocity * cycle) / 100 + offset);
            const y = ((this.size * 1.5) + stationaryRadius) * Math.sin((stationaryVelocity * cycle) / 100 + offset);
            satellite.setPosition(new Vector2(x, y));
            satellite.setRotation(stationaryVelocity * ( this.cycleSize / 100 ));
            satellite.cycle += this.cycleSize * this.system.fpsRatio;
        }
    }

    protected removeAllSatellites() {
        // for (let i = 0; i < this.satellites.length; i++) {
        //     const satellite = this.satellites[i];
        //     satellite.hide();
        //     this.planetMap.storagePlanet(planet);
        // }
        this.satellites = [];
    }

    protected fixeSatellite(satellite: SatelliteEntity) {
        satellite.setParent(this.transformMesh);
        this.satellites.push(satellite);
    }

    private grabAnimationLength = 50;

    protected grabSatellite(satellite: SatelliteEntity, radius: number, velocity: number) {
        let xgap = this.position.x - satellite.position.x;
        let ygap = this.position.y - satellite.position.y;
        let offset = (xgap > 0) ? Math.atan(ygap / xgap) + Math.PI : Math.atan(ygap / xgap);
        satellite.setOffset(offset);

        let dist = Vector2.Distance(satellite.position, this.position);
        let radiusTemp = dist - this.size;
        let radiusChange = radiusTemp - radius;
        satellite.setGeostationnaryMovement(radius + radiusChange, 0);
        satellite.satelliteAnimation.simple(this.grabAnimationLength, (count, perc) => {
            let progress = grabCurve.ease(perc);
            satellite.setGeostationnaryMovement(radius + (1 - progress) * radiusChange, progress * velocity);
        }, () => {
            satellite.setGeostationnaryMovement(radius, velocity);
        });
    }

}